/**
 * App 전역 Store 모듈
 * @module shared/store/useAppStore
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * App Store Interface
 */
interface AppState {
  /**
   * 헤더 프로필 이미지 및 닉네임 표시 여부
   */
  isShowHeaderNickName: boolean;

  /**
   * 하단 메뉴 표시 여부
   */
  isShowBottomNavigation: boolean;

  isShowProfileHeader: boolean;

  setIsShowHeaderNickName: (isShowHeaderNickName: boolean) => void;

  setIsShowBottomNavigation: (isShowBottomNavigation: boolean) => void;

  setIsShowProfileHeader: (isShowProfileHeader: boolean) => void;
}

/**
 * AppStore를 생성한다.
 */
const useAppStore = create<AppState>()(
  persist(
    (set, get) => ({
      isShowHeaderNickName: true,
      isShowBottomNavigation: true,
      isShowProfileHeader: true,
      setIsShowHeaderNickName: (isShowHeaderNickName: boolean) => set({ isShowHeaderNickName }),
      setIsShowBottomNavigation: (isShowBottomNavigation: boolean) =>
        set({ isShowBottomNavigation }),
      setIsShowProfileHeader: (isShowProfileHeader: boolean) => set({ isShowProfileHeader }),
    }),
    {
      name: 'app-storage',
    },
  ),
);

export default useAppStore;
